/* istanbul ignore file */

export const sendCloudinaryAnalytics = async ({ eventName, ...eventParams }: { eventName: string }) => {
  const searchParams = new URLSearchParams({ ...eventParams });
  return fetch(`https://analytics-api.cloudinary.com/${eventName}?${searchParams.toString()}`);
};
